import React from 'react';
import { Route, Switch } from 'react-router-dom';

import SearchPage from './search';
import SummaryPage from './summary';

import { LR_REQUEST_TYPE } from 'modules/main/lab_request/steps/constants';

function ViewRequestPage(){
  //set LR_REQUEST_TYPE value to 'create', to show selected columns only
  //check 'shared_components/search_patient_table' for table reference
  sessionStorage.setItem(LR_REQUEST_TYPE, 'create');

  return (
    <div>
      <Switch>
        <Route exact path={`/request/view/search`} render={()=> <SearchPage />} />
        <Route exact path={`/request/view/summary`} render={()=> <SummaryPage />} />
      </Switch>
    </div>
  );
}

export default ViewRequestPage;